import { LimitType } from 'legoland-sdk/dist/experimental';
import styled from 'styled-components';
import { Alert, Box, Button, Modal, Text, tombac, useToasts } from 'tombac';
import { LenghtIcon, ReportIcon } from 'tombac-icons';
import { useUpdateContractProductSharedLimitMutation } from "../contractsApiHooks";
import { ProductModalHeader } from "./ProductModalHeader";
import { sharedLimitSchemas } from "./sharedLimitSchemas";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const Container = styled.div.withConfig({
  displayName: "DeleteSharedLimitsModal__Container"
})(["display:flex;flex-direction:column;padding-left:", ";"], tombac.space(1));
const Title = styled.div.withConfig({
  displayName: "DeleteSharedLimitsModal__Title"
})(["", ";padding-bottom:", ";"], tombac.altText({
  fontSize: 12,
  fontWeight: 'bold'
}), tombac.space(1));
export const DeleteSharedLimitsModal = ({
  isOpen,
  onRequestClose,
  limits,
  contractId
}) => {
  const limitsExist = limits && Object.values(limits).length > 0;
  const {
    addToast
  } = useToasts();
  const {
    isLoading: isRemoving,
    mutateAsync: updateContractProductSharedLimits
  } = useUpdateContractProductSharedLimitMutation();
  const handleRemove = async () => {
    try {
      await updateContractProductSharedLimits({
        contractId: contractId,
        limits: {
          limits: {}
        }
      });
      onRequestClose();
    } catch (error) {
      addToast('Could not delete the shared limits', 'danger', {
        content: 'Please try again later or contact MOVE support.'
      });
    }
  };
  const limitsCount = Object.keys(limits).length;
  return /*#__PURE__*/_jsxs(Modal, {
    isOpen: isOpen,
    onRequestClose: onRequestClose,
    "data-sentry-element": "Modal",
    "data-sentry-component": "DeleteSharedLimitsModal",
    "data-sentry-source-file": "DeleteSharedLimitsModal.tsx",
    children: [/*#__PURE__*/_jsx(ProductModalHeader, {
      onRequestClose: onRequestClose,
      subtitle: "By deleting the shared limits you are removing the package.",
      title: "Do you want to delete the shared limits?",
      "data-sentry-element": "ProductModalHeader",
      "data-sentry-source-file": "DeleteSharedLimitsModal.tsx",
      "data-sentry-element": "ProductModalHeader"
    }), limitsExist ? sharedLimitSchemas.map(schemaItem => Object.hasOwn(limits, schemaItem.name) && /*#__PURE__*/_jsxs(Box, {
      $m: "0 4sp 12u",
      $p: "2sp 1sp",
      $display: "flex",
      $alignItems: "center",
      $border: "1u solid --neutral-400",
      children: [schemaItem.type === LimitType.Km ? /*#__PURE__*/_jsx(LenghtIcon, {
        size: 'lg'
      }) : /*#__PURE__*/_jsx(ReportIcon, {
        size: 'lg'
      }), /*#__PURE__*/_jsxs(Container, {
        children: [/*#__PURE__*/_jsx(Title, {
          children: schemaItem.label
        }), /*#__PURE__*/_jsxs(Text, {
          variant: "secondary",
          children: [limits[schemaItem.name] && limits[schemaItem.name].toString(), ' ', schemaItem.type === LimitType.Km ? 'km' : '']
        })]
      })]
    }, schemaItem.name)) : /*#__PURE__*/_jsx(Text, {
      as: "span",
      $mt: "0.2em",
      children: "No limits are set."
    }), /*#__PURE__*/_jsx(Box, {
      $display: "flex",
      $pb: "3sp",
      $pl: "4sp",
      $pr: "4sp",
      $maxWidth: "560px",
      "data-sentry-element": "Box",
      "data-sentry-source-file": "DeleteSharedLimitsModal.tsx",
      "data-sentry-element": "Box",
      children: /*#__PURE__*/_jsx(Alert, {
        title: "Changing existing limits",
        variant: "alert",
        "data-sentry-element": "Alert",
        "data-sentry-source-file": "DeleteSharedLimitsModal.tsx",
        "data-sentry-element": "Alert",
        children: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("span", {
            children: "All the access information will be kept, however the"
          }), ' ', limits['totalRoadNetwork'] !== undefined && /*#__PURE__*/_jsx("b", {
            children: "number of kilometers to consume"
          }), limitsCount === 2 && /*#__PURE__*/_jsx("span", {
            children: " as well as "
          }), limits['agreementJobs'] !== undefined && /*#__PURE__*/_jsx("b", {
            children: "number of reports"
          }), /*#__PURE__*/_jsxs("span", {
            children: [' ', "would need to be adjusted manually (to match the contract details). Without any changes ", limitsCount > 1 ? 'they' : 'it', ' ', "will be automatically set to the default value", limitsCount > 1 ? 's' : '', " for each product."]
          })]
        })
      })
    }), /*#__PURE__*/_jsxs(Box, {
      $display: "flex",
      $pb: "3sp",
      $pr: "4sp",
      $pt: "2sp",
      "data-sentry-element": "Box",
      "data-sentry-source-file": "DeleteSharedLimitsModal.tsx",
      "data-sentry-element": "Box",
      children: [/*#__PURE__*/_jsx(Button, {
        $ml: "auto",
        onClick: onRequestClose,
        type: "button",
        variant: "flat",
        "data-sentry-element": "Button",
        "data-sentry-source-file": "DeleteSharedLimitsModal.tsx",
        "data-sentry-element": "Button",
        children: "Cancel"
      }), /*#__PURE__*/_jsx(Button, {
        $ml: "1sp",
        busy: isRemoving,
        disabled: !isOpen,
        onClick: handleRemove,
        type: "submit",
        variant: "primary",
        "data-sentry-element": "Button",
        "data-sentry-source-file": "DeleteSharedLimitsModal.tsx",
        "data-sentry-element": "Button",
        children: "Yes, delete shared limits"
      })]
    })]
  });
};